import type { Dispatch, SetStateAction } from 'react';
import type { FileInfo } from 'src/pages/advisor/dashboard/marketing/asset/[boxFileId]';
import { Button } from '@savvy-kit/components/button';
import { Separator } from '@savvy-kit/components/separator';
import { Text } from '@savvy-kit/foundations/text';

function AssetDownloadSizes({
  size,
  setSize,
  selectedFormat,
  fileInfo,
}: {
  readonly size: string;
  readonly setSize: Dispatch<SetStateAction<string>>;
  readonly selectedFormat: string;
  readonly fileInfo: FileInfo;
}) {
  const originalFormat = fileInfo.originalFormat;
  const representations = fileInfo.representations;

  const handleDimensionsChange = (event: React.MouseEvent<HTMLButtonElement>) => {
    setSize(event.currentTarget.value);
  };

  const matchingReps = representations.filter((item) => {
    return item.representation === selectedFormat;
  });

  const dimensionsButtons = matchingReps.map((rep) => {
    if (!rep.properties?.dimensions) {
      return;
    }
    const dimensions = rep.properties.dimensions;
    const displayDimension = `${dimensions.substring(dimensions.indexOf('x') + 1)} px`;
    const isSelected = size === dimensions;
    return (
      <Button
        key={dimensions}
        value={dimensions}
        variant="secondary"
        size="sm"
        className={`w-[100px] ${isSelected && 'bg-component-hover'}`}
        onClick={handleDimensionsChange}
      >
        {displayDimension}
      </Button>
    );
  });
  return (
    <>
      <Separator className="bg-border-light" />
      <div className="flex flex-col gap-2 p-4 pt-2 w-full">
        <Text variant="subtitle-sm">Size</Text>
        <div className="flex flex-col gap-2">
          {originalFormat === selectedFormat && (
            <Button
              value=""
              variant="secondary"
              size="sm"
              className={`w-[100px] ${size === '' && 'bg-component-hover'}`}
              onClick={handleDimensionsChange}
            >
              Original
            </Button>
          )}
          {dimensionsButtons}
        </div>
      </div>
    </>
  );
}

export default AssetDownloadSizes;
